import { useNavigate } from '@tanstack/react-router';
import { Command } from 'cmdk';

import { CommandBarTypedItem } from '#components/command-bar/components/command-bar-typed-item.js';
import { organizationLabel, useCommandBarOrganization } from './use-command-bar-organization.js';

import type { CadstromUidResultProps } from '../cadstrom-uid-types.js';

/**
 * Renders a command-bar result for an organization id (`org_...`) that navigates
 * to the organization's home page.
 *
 * @param uid - The organization id to resolve and display.
 * @param onClose - Dismisses the command bar once navigation begins.
 */
export function OrganizationUidResult({ uid, onClose }: CadstromUidResultProps) {
	const navigate = useNavigate();
	const organization = useCommandBarOrganization(uid);

	if (!organization) {
		return null;
	}

	const label = organizationLabel(organization);

	return (
		<Command.Group heading='Organizations'>
			<Command.Item
				value={uid}
				keywords={[organization.organizationName, label, 'organization', 'org']}
				onSelect={() => {
					void navigate({ to: '/orgs/$orgName', params: { orgName: organization.organizationName } });
					onClose();
				}}
			>
				<CommandBarTypedItem type='organization' name={label}>
					{label !== organization.organizationName && (
						<span className='truncate font-normal text-gray-a11'>{organization.organizationName}</span>
					)}
				</CommandBarTypedItem>
			</Command.Item>
		</Command.Group>
	);
}
